import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Crne ovce",
  "description": "",
  "published": "2007-01-13T00:00:00.000Z",
  "redirect_from": ["/blog/crne-ovce/swizec/322"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Na `}<a parentName="p" {...{
        "href": "http://www.commissionedcomic.com"
      }}>{`Commissioned`}</a>{` sem nasel cudovit predogled filma, ki deluje tako zelo neresnicen, da sem kar presenecen ob dejstvu, da je resnicen. Kot je rekel O noben opis temu ne naredi pravice, zato si ga kar oglejte.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.ifilm.com/video/2810911"
      }}>{`Pojte sem`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      